module.exports = __webpack_public_path__ + "conheca/static/media/background.46a38fe4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/Home/background.jpg
// module id = 326
// module chunks = 37